/**
 * ***********************
 * Org Routes Components *
 * ***********************
 */
const Users = () => import('@/components/Organisations/Users/index');

export default {
  title: 'Users and Groups',
  link: '/configuration/users-groups',
  permission: [
    {
      action: 'view',
      entity: 'user'
    }
  ],
  path: 'users-groups',
  component: Users,
  meta: {
    permission: [
      {
        action: 'view',
        entity: 'user'
      }
    ],
    id: 'configuration__users-groups-tab'
  }
};
